import { Box, Stack } from '@mui/material';
import { useState } from 'react';

import {
  ValuesWater,
  VenueCo2MonthValues,
} from '@/domain/project-venue-month-declaration/entities/project-venue-month-declaration';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { FSTextField } from '@/ui/components/input/FSTextField';
import { language, translate } from '@/ui/i18n';

import { QuizEdition, QuizNotEdition } from '../Co2MonthQuizComponents';
import { useMonthDeclarationDisableSubmit } from './hooks/useMonthDeclarationDisableSubmit';

export function WaterForm({
  onEdit,
  co2MonthValues,
}: {
  onEdit: (co2Values: VenueCo2MonthValues) => void;
  co2MonthValues: VenueCo2MonthValues;
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [values, setValues] = useState<ValuesWater>(
    structuredClone(co2MonthValues.water),
  );

  const { disableSubmitActions } = useMonthDeclarationDisableSubmit();

  const onFormChange = (value: number) => {
    setValues({
      ...values,
      waterConsumptionVolume: parseFloat(value.toString()),
    });
  };

  const handleEdit = () => {
    onEdit({ ...co2MonthValues, water: values });
    setIsEditing(false);
  };

  const handleRemoveClick = () => {
    setIsEditing(false);
  };

  return (
    <div>
      {isEditing ? (
        <QuizEdition
          removeFromEditing={handleRemoveClick}
          title={translate('ProjectsVenue.MonthCo2Quiz.Water.how-much-water')}
          form={
            <Form
              onChange={onFormChange}
              onSubmit={handleEdit}
              values={values}
              disableSubmit={disableSubmitActions}
            />
          }
        />
      ) : (
        <QuizNotEdition
          addToEditing={() => setIsEditing(true)}
          answeredValues={[
            `${values?.waterConsumptionVolume.toLocaleString(language)} m³`,
          ]}
          title={translate('ProjectsVenue.MonthCo2Quiz.Water.how-much-water')}
          isAnswered={
            values?.waterConsumptionVolume !== undefined &&
            !Number.isNaN(values.waterConsumptionVolume)
          }
        />
      )}
    </div>
  );
}

function Form({
  onChange,
  disableSubmit,
  onSubmit,
  values,
}: {
  onChange: (value: number) => void;
  onSubmit: () => void;
  disableSubmit: boolean;
  values: ValuesWater;
}) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    onChange(value);
  };

  const handleSubmit = () => {
    onSubmit();
  };

  let value: string;
  if (Number.isNaN(values?.waterConsumptionVolume)) {
    value = '';
  } else {
    value = values?.waterConsumptionVolume.toString();
  }

  values?.waterConsumptionVolume.toString();
  return (
    <Stack>
      <FSTextField
        type="number"
        value={value}
        label={translate('ImpactQuestion.WATER.waterConsumptionVolumeTitle')}
        onChange={handleChange}
      />
      <Box marginTop={2}>
        <FSPrimaryButton
          type="submit"
          disabled={disableSubmit}
          onClick={handleSubmit}
        >
          {translate('Form.save')}
        </FSPrimaryButton>
      </Box>
    </Stack>
  );
}
